import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type ConditionFormTypes = {
  conditionClass: string[];
  minVoltage: number;
  maxVoltage: number;
};

export const conditionFormDefaults: ConditionFormTypes = {
  conditionClass: [],
  maxVoltage: 0,
  minVoltage: 0,
};

export const ConditionForm = ({ isDisabled = true }: SharedFormProps) => {
  const { t } = useTranslation("fairwayReport");
  const { control } = useFormContext<ConditionFormTypes>();
  const condiditionOptions = React.useMemo(
    () => [
      { label: t("securityDeviceSearch:kunnossa"), value: "good" },
      { label: t("securityDeviceSearch:tolerable"), value: "decent" },
      { label: t("securityDeviceSearch:huono"), value: "poor" },
    ],
    [t],
  );
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {/* <Typography>{t("fairwayReport:deviceIdOrName")}</Typography> */}

      <FormControl disabled={isDisabled}>
        <FormLabel>{t("fairwayReport:conditionClass")}</FormLabel>
        <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
          <Controller
            name="conditionClass"
            control={control}
            render={({ field }) => (
              <>
                {condiditionOptions.map((option) => (
                  <FormControlLabel
                    key={option.value}
                    label={option.label}
                    control={
                      <Checkbox
                        value={option.value}
                        checked={field.value.some((v) => v === option.value)}
                        onChange={(event, checked) => {
                          if (checked) {
                            field.onChange([
                              ...field.value,
                              event.target.value,
                            ]);
                          } else {
                            field.onChange(
                              field.value.filter(
                                (value) => value !== event.target.value,
                              ),
                            );
                          }
                        }}
                      />
                    }
                  />
                ))}
              </>
            )}
          />
        </FormGroup>
      </FormControl>
      {/* <SmartTextField<ConditionFormTypes>
        name="minVoltage"
        label={t("fairwayReport.voltageSearch")}
        controllerProps={{ control }}
        inputProps={{}}
        InputProps={{}}
      /> */}
      {/* <FormControl disabled={isDisabled}>
        <FormLabel>{t("fairwayReport:voltageSearch")}</FormLabel>
        <Box
          sx={{ display: "flex", gap: "20px", minWidth: "170px", width: "35%" }}
        >
          <SmartTextField<ConditionFormTypes>
            name="minVoltage"
            type="number"
            fullWidth
            autoComplete="off"
            controllerProps={{ control }}
            InputProps={{ endAdornment: "V" }}
            disabled={isDisabled}
          />
          <Box>
            <Typography variant="h4">-</Typography>
          </Box>

          <SmartTextField<ConditionFormTypes>
            InputProps={{ endAdornment: "V" }}
            name="maxVoltage"
            type="number"
            fullWidth
            autoComplete="off"
            controllerProps={{ control }}
            disabled={isDisabled}
          />
        </Box>
      </FormControl> */}
    </Box>
  );
};
